export const storeProducts = [
  {
    id: 'prod-1',
    name: 'Legging Fitness Premium',
    category: 'store.category.fashion',
    price: 149.90,
    image: 'https://readdy.ai/api/search-image?query=Black%20women%20athletic%20leggings%20with%20subtle%20mesh%20panel%20detail%20on%20calves%20folded%20neatly%20on%20light%20wooden%20surface%20natural%20daylight%20streaming%20from%20window%20soft%20shadows%20fabric%20texture%20visible%20realistic%20product%20photo%20lifestyle%20fitness%20apparel&width=600&height=800&seq=store-legging-v2-001&orientation=portrait',
  },
  {
    id: 'prod-2',
    name: 'Top Dry-Fit Essential',
    category: 'store.category.fashion',
    price: 89.90,
    image: 'https://readdy.ai/api/search-image?query=Dark%20grey%20women%20athletic%20crop%20top%20dry-fit%20fabric%20with%20racerback%20design%20hanging%20on%20wooden%20hanger%20against%20light%20concrete%20wall%20natural%20sunlight%20warm%20tones%20realistic%20fitness%20apparel%20product%20photography%20textured%20fabric&width=600&height=800&seq=store-top-v2-002&orientation=portrait',
  },
  {
    id: 'prod-3',
    name: 'Whey Protein 900g',
    category: 'store.category.supplements',
    price: 179.90,
    image: 'https://readdy.ai/api/search-image?query=Large%20black%20whey%20protein%20supplement%20tub%20with%20white%20label%20and%20nutrition%20facts%20sitting%20on%20gym%20wooden%20bench%20surface%20with%20small%20scoop%20beside%20it%20warm%20gym%20lighting%20realistic%20product%20shot%20textured%20container%20subtle%20reflections%20not%20flat%20studio&width=600&height=800&seq=store-whey-v2-003&orientation=portrait',
  },
  {
    id: 'prod-4',
    name: 'Creatina Monohidratada 300g',
    category: 'store.category.supplements',
    price: 99.90,
    image: 'https://readdy.ai/api/search-image?query=White%20creatine%20monohydrate%20supplement%20jar%20with%20green%20label%20on%20dark%20rubber%20gym%20floor%20surface%20with%20metal%20shaker%20bottle%20blurred%20in%20background%20realistic%20fitness%20supplement%20product%20photography%20natural%20gym%20environment&width=600&height=800&seq=store-creatine-v2-004&orientation=portrait',
  },
  {
    id: 'prod-5',
    name: 'Garrafa Shaker 700ml',
    category: 'store.category.accessories',
    price: 59.90,
    image: 'https://readdy.ai/api/search-image?query=Black%20matte%20protein%20shaker%20bottle%20700ml%20with%20measurement%20markings%20on%20side%20placed%20on%20wooden%20gym%20locker%20room%20bench%20natural%20light%20realistic%20product%20shot%20condensation%20droplets%20visible%20steel%20mixing%20ball%20inside%20lid%20off%20beside%20it&width=600&height=800&seq=store-shaker-v2-005&orientation=portrait',
  },
  {
    id: 'prod-6',
    name: 'Tapete de Yoga Premium',
    category: 'store.category.accessories',
    price: 129.90,
    image: 'https://readdy.ai/api/search-image?query=Dark%20teal%20yoga%20mat%20rolled%20up%20with%20carrying%20strap%20leaning%20against%20light%20wall%20in%20gym%20studio%20corner%20natural%20daylight%20cork%20block%20beside%20it%20realistic%20texture%20visible%20mat%20surface%20subtle%20grip%20pattern%20warm%20atmosphere&width=600&height=800&seq=store-yogamat-v2-006&orientation=portrait',
  },
  {
    id: 'prod-7',
    name: 'Luvas de Treino',
    category: 'store.category.accessories',
    price: 69.90,
    image: 'https://readdy.ai/api/search-image?query=Black%20leather%20gym%20training%20gloves%20with%20red%20stitching%20and%20padded%20palms%20lying%20flat%20on%20wooden%20gym%20bench%20surface%20realistic%20product%20shot%20worn-in%20texture%20grip%20detail%20visible%20natural%20gym%20lighting%20slightly%20used%20look%20authentic&width=600&height=800&seq=store-gloves-v2-007&orientation=portrait',
  },
  {
    id: 'prod-8',
    name: 'Camiseta Dry-Fit Masculina',
    category: 'store.category.fashion',
    price: 79.90,
    image: 'https://readdy.ai/api/search-image?query=Dark%20navy%20blue%20men%20athletic%20dry-fit%20t-shirt%20with%20subtle%20logo%20on%20chest%20folded%20on%20wooden%20surface%20natural%20window%20light%20realistic%20fabric%20texture%20visible%20seams%20and%20stitching%20warm%20casual%20product%20photography%20lifestyle%20gym%20apparel&width=600&height=800&seq=store-tshirt-v2-008&orientation=portrait',
  },
];